import loginQuery from '~layers/app/graphql/account/login.gql'

export function useAccountLogin() {
  const {
    mutate: loginMutation,
    loading: loginLoading,
    called: loginCalled,
    error: loginError,
  } = useMutation(
    loginQuery,
    { clientId: 'customer' },
  )

  const login = async ({ email, password }: { email: string, password: string }) => {
    try {
      const result = await loginMutation({ email, password })
      const { onLogin } = useApollo()
      await onLogin(`Bearer ${result?.data.login.token}`, 'customer')
      const { reset, load } = useAccount()
      reset()
      await load()
    }
    catch (loginException: any) {
      console.error('loginException', loginException)
    }
  }

  return {
    login,
    loginCalled,
    loginError,
    loginLoading,
  }
}
